"use client";

import { useRef } from "react";
import Close from "@mui/icons-material/Close";
import { IconButton, SwipeableDrawer } from "@mui/material";
import { useTranslations } from "next-intl";

export interface CustomSwipeableDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  drawerClassName?: string;
}

export default function CustomSwipeableDrawer({
  isOpen,
  onClose,
  children,
  drawerClassName,
}: CustomSwipeableDrawerProps) {
  const anchorRef = useRef<HTMLDivElement>(null);
  const tAria = useTranslations("aria");

  return (
    <div ref={anchorRef}>
      <SwipeableDrawer
        className={drawerClassName}
        anchor="bottom"
        open={isOpen}
        onClose={onClose}
        onOpen={() => {}}
        disableSwipeToOpen
        swipeAreaWidth={0}
        // The component will naturally render at the root, the following line will render it within the .sap scope so styles will apply
        container={
          anchorRef.current?.closest(".sap") as HTMLElement | undefined
        }
      >
        <div className="custom-swipeable-drawer-grabber-area">
          <div className="custom-swipeable-drawer-grabber" />
        </div>
        <div className="custom-swipeable-drawer-header">
          <IconButton
            className="custom-swipeable-drawer-close-button"
            onClick={onClose}
            aria-label={tAria("close")}
          >
            <Close aria-hidden focusable={false} />
          </IconButton>
        </div>
        {children}
      </SwipeableDrawer>
    </div>
  );
}
